interface SegmentPayload {
  segmentEventName: string;
  properties: SegmentProperties;
  userId?: string | number;
}

interface SegmentProperties {
  [key: string]: string | number | { [key: string]: string | number };
}

export function segmentTracking(segmentPayload: SegmentPayload): void {
  if (window.HAS_SEGMENT_INTEGRATION) {
    const csrf = $('meta[name="csrf-token"]').attr('content');
    const payloadWithCsrf = {
      ...segmentPayload,
      authenticity_token: csrf,
    };
    const blob = new Blob([JSON.stringify(payloadWithCsrf)], { type: 'application/json' });

    navigator.sendBeacon('/api/segment_integration/track', blob);
  }
}
